import styled from 'styled-components';
import { BodyRegularS } from '@/styles/globals';
import { ITheme } from '@/styles/theme';

interface ChangeOrgButtonProps {
  theme: ITheme;
  active?: boolean;
}

export const OrgChangeButton = styled.div<ChangeOrgButtonProps>`
  width: 136px;
  border: none;
  outline: none;
  margin: 0;
  height: 43px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ${({ theme, active }) => `
    background: ${active ? theme.colors.neutral.primary[5] : 'transparent'};
    color: ${active ? theme.colors.primary[100] : theme.colors.neutral.primary[5]};
  
    &:hover {
      border: ${active ? 'none' : `2px solid ${theme.colors.neutral.primary[5]}`};
    }

    span {
      font-weight: ${active ? '700' : '400'};
    }
  `}
`;

export const OrgChangeTitle = styled(BodyRegularS)`
  text-transform: capitalize;
`;
